import { render, staticRenderFns } from "./ClinicSearchForm.vue?vue&type=template&id=24602c58&scoped=true"
import script from "./ClinicSearchForm.vue?vue&type=script&lang=js"
export * from "./ClinicSearchForm.vue?vue&type=script&lang=js"
import style0 from "./ClinicSearchForm.vue?vue&type=style&index=0&id=24602c58&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24602c58",
  null
  
)

export default component.exports